/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DeleteCookies: BridgeCommands.Command<
    Types.Common.Applicationcontrol.DeleteCookiesParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_DELETE_COOKIES',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'DeleteCookies',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetTaskbarProgress: BridgeCommands.Command<
    Types.Common.Applicationcontrol.SetTaskbarProgressParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_WIN_TASKBAR_PROGRESS',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'SetTaskbarProgress',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const LoadStringTable: BridgeCommands.Command<
    Types.Common.Applicationcontrol.LoadStringTableParameters,
    void
    > = {
    legacyCommand: 'QUERY_LOAD_STRING_TABLE',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'LoadStringTable',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ReadConfig: BridgeCommands.Command<
    Types.Common.Applicationcontrol.ReadConfigParameters,
    string
    > = {
    legacyCommand: 'QUERY_READ_CONFIG',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'ReadConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const WriteConfig: BridgeCommands.Command<
    Types.Common.Applicationcontrol.WriteConfigParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_WRITE_CONFIG',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'WriteConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ReadGenericConfig: BridgeCommands.Command<
    Types.Common.Applicationcontrol.ReadGenericConfigParameters,
    Types.Common.Applicationcontrol.ReadReturn
    > = {
    legacyCommand: 'QUERY_READ_GENERIC_CONFIG',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'ReadGenericConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const WriteGenericConfig: BridgeCommands.Command<
    Types.Common.Applicationcontrol.WriteGenericConfigParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_WRITE_GENERIC_CONFIG',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'WriteGenericConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RemoveFromGenericConfig: BridgeCommands.Command<
    Types.Common.Applicationcontrol.RemoveParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_REMOVE_FROM_GENERIC_CONFIG',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'RemoveFromGenericConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AllowSetForegroundWindow: BridgeCommands.Command<
    Types.Common.Applicationcontrol.AllowSetForegroundWindowParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_WIN_ALLOW_SET_FOREGROUND',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'AllowSetForegroundWindow',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CopyToClipboard: BridgeCommands.Command<
    Types.Common.Applicationcontrol.CopyToClipboardParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_WIN_COPY_TO_CLIPBOARD',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'CopyToClipboard',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Restart: BridgeCommands.Command<
    Types.Common.Applicationcontrol.RestartParameters,
    string
    > = {
    legacyCommand: 'QUERY_RESTART_APP',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'Restart',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsCefGpuModeSupported: BridgeCommands.Command<
    {},
    boolean
    > = {
    legacyCommand: 'QUERY_IS_CEF_GPU_MODE_SUPPORTED',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'IsCefGpuModeSupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RequestLastInstallerStatus: BridgeCommands.Command<
    {},
    Types.Common.Applicationcontrol.LastInstallerStatusReturn
    > = {
    legacyCommand: 'QUERY_LAST_INSTALLER_STATUS',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'RequestLastInstallerStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ModulesActiveNotification: BridgeCommands.Command<
    {},
    Types.Common.Applicationcontrol.ModulesActiveNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_MODULES_ACTIVE_NOTIFICATION',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'ModulesActiveNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OpenLinkInExternalBrowser: BridgeCommands.Command<
    Types.Common.Applicationcontrol.OpenLinkInExternalBrowserParameters,
    any
    > = {
    legacyCommand: 'QUERY_OPEN_LINK_EXTERNAL_BROWSER',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'OpenLinkInExternalBrowser',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetCEFWindowTheme: BridgeCommands.Command<
    Types.Common.Applicationcontrol.SetCEFWindowThemeParameters,
    boolean
    > = {
    legacyCommand: 'QUERY_SET_SYSTEM_THEME_TO_BROWSER_WINDOW',
    system: 'CrimsonNative',
    module: 'ApplicationControl',
    method: 'SetCEFWindowTheme',
    persistent: false
};

export const Applicationcontrol = {
DeleteCookies,
SetTaskbarProgress,
LoadStringTable,
ReadConfig,
WriteConfig,
ReadGenericConfig,
WriteGenericConfig,
RemoveFromGenericConfig,
AllowSetForegroundWindow,
CopyToClipboard,
Restart,
IsCefGpuModeSupported,
RequestLastInstallerStatus,
ModulesActiveNotification,
OpenLinkInExternalBrowser,
SetCEFWindowTheme
};
